import React from 'react';

import './Padding.css';

interface PaddingProps {
  children: React.ReactNode;
  customMaxWidth?: number;
}

const Padding: React.FC<PaddingProps> = ({ children, customMaxWidth }) => {
  return (
    <div
      id="padding"
      className="ion-padding"
      style={customMaxWidth ? { maxWidth: `${customMaxWidth}px` } : {}}
    >
      {children}
    </div>
  );
};

export default Padding;
